import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {EventTypeApiModel} from "./event-type-api-model";

export class EventTypeDomainModel extends BaseDomainModel {
  apiModel: EventTypeApiModel;

  get name(){
    return this.apiModel.name;
  }

  get subTypeName(){
    return this.apiModel.subTypeName;
  }

  get subTypeId(){
    return this.apiModel.subTypeId;
  }
}
